import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import RestaurantHero from '../components/RestaurantHero';
import RestaurantValueCards from '../components/RestaurantValueCards';
import SocialProof from '../components/SocialProof';
import HowItWorks from '../components/HowItWorks';
import FlavorCircles from '../components/FlavorCircles';
import RestaurantFunctionalShots from '../components/RestaurantFunctionalShots';
import RestaurantComparisonTable from '../components/RestaurantComparisonTable';
import CustomerStories from '../components/CustomerStories';
import RestaurantPricingStrip from '../components/RestaurantPricingStrip';
import RestaurantFAQ from '../components/RestaurantFAQ';
import CTASection from '../components/CTASection';
import RestaurantQuickSavingsEstimator from '../components/RestaurantQuickSavingsEstimator';
import RestaurantOwnerEssentials from '../components/RestaurantOwnerEssentials';
import RestaurantImageGallery from '../components/RestaurantImageGallery';
import SEO from '../components/SEO';
const RestaurantsPage = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1609">
      <SEO title="SmartSoda for Restaurants | Premium Beverage Solutions | 60%+ Profit Margins" description="Elevate your restaurant's beverage offerings with SmartSoda. Premium craft drinks, 60%+ profit margins, reduced storage needs, and sustainable solutions for modern dining." keywords="restaurant beverages, craft drinks, premium drinks for restaurants, restaurant profit margins, sustainable restaurant solutions, SmartSoda restaurant" data-id="element-1610" />
      <Navbar data-id="element-1611" />
      <main className="flex-grow" id="main-content" data-id="element-1612">
        <RestaurantHero data-id="element-1613" />
        <RestaurantValueCards data-id="element-1614" />
        <SocialProof data-id="element-1615" />
        <RestaurantImageGallery data-id="element-1616" />
        <HowItWorks data-id="element-1617" />
        <FlavorCircles data-id="element-1618" />
        <RestaurantFunctionalShots data-id="element-1619" />
        <RestaurantComparisonTable data-id="element-1620" />
        <RestaurantQuickSavingsEstimator data-id="element-1621" />
        <CustomerStories data-id="element-1622" />
        <RestaurantPricingStrip data-id="element-1623" />
        <RestaurantOwnerEssentials data-id="element-1624" />
        <RestaurantFAQ data-id="element-1625" />
        <CTASection data-id="element-1626" />
      </main>
      <Footer data-id="element-1627" />
    </div>;
};
export default RestaurantsPage;